module.exports = __webpack_public_path__ + "static/media/logo_dark_transparent.58f9984a.svg";